/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_File_Exists_TitleInputs */

const en_video_export_file_exists_title = /** @type {(inputs: Video_Export_File_Exists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Already Exists`)
};

const fr_video_export_file_exists_title = /** @type {(inputs: Video_Export_File_Exists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le fichier existe deja`)
};

const de_video_export_file_exists_title = /** @type {(inputs: Video_Export_File_Exists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei existiert bereits`)
};

const it_video_export_file_exists_title = /** @type {(inputs: Video_Export_File_Exists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il file esiste gia`)
};

const ru_video_export_file_exists_title = /** @type {(inputs: Video_Export_File_Exists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл уже существует`)
};

const es_video_export_file_exists_title = /** @type {(inputs: Video_Export_File_Exists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El archivo ya existe`)
};

const zh_cn2_video_export_file_exists_title = /** @type {(inputs: Video_Export_File_Exists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件已存在`)
};

const ja_video_export_file_exists_title = /** @type {(inputs: Video_Export_File_Exists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルは既に存在します`)
};

const hi_video_export_file_exists_title = /** @type {(inputs: Video_Export_File_Exists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल पहले से मौजूद है`)
};

const pt_pt2_video_export_file_exists_title = /** @type {(inputs: Video_Export_File_Exists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O ficheiro ja existe`)
};

/**
* | output |
* | --- |
* | "File Already Exists" |
*
* @param {Video_Export_File_Exists_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_file_exists_title = /** @type {((inputs?: Video_Export_File_Exists_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_File_Exists_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_file_exists_title(inputs)
	if (locale === "de") return de_video_export_file_exists_title(inputs)
	if (locale === "it") return it_video_export_file_exists_title(inputs)
	if (locale === "ru") return ru_video_export_file_exists_title(inputs)
	if (locale === "es") return es_video_export_file_exists_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_file_exists_title(inputs)
	if (locale === "ja") return ja_video_export_file_exists_title(inputs)
	if (locale === "hi") return hi_video_export_file_exists_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_file_exists_title(inputs)
	return en_video_export_file_exists_title(inputs)
});